import React from 'react'
import {Form, OverlayTrigger, Tooltip} from 'react-bootstrap'

interface ToggleSwitchProps {
  id: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  helpText?: string
  disabled?: boolean
  helpTextClass?: string
  tooltip?: string
  ariaLabel?: string
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  label,
  checked,
  onChange,
  helpText,
  helpTextClass,
  disabled = false,
  tooltip,
  ariaLabel,
}) => {
  const switchControl = (
    <Form.Check
      type='switch'
      id={id}
      label={label}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      aria-label={ariaLabel}
    />
  )

  return (
    <div>
      {tooltip ? (
        <OverlayTrigger
          placement='top'
          trigger={['hover', 'focus']}
          delay={{show: 80, hide: 80}}
          container={typeof document !== 'undefined' ? document.body : undefined}
          overlay={
            <Tooltip
              id={`${id}-tooltip`}
              className='toggle-switch-tooltip'
              style={{zIndex: 10050, position: 'fixed'}}
            >
              {tooltip}
            </Tooltip>
          }
        >
          <span
            className='d-inline-flex align-items-center'
            tabIndex={0}
            role='button'
            aria-disabled={disabled}
            aria-describedby={`${id}-tooltip`}
            aria-label={tooltip}
            style={{
              cursor: disabled ? 'not-allowed' : undefined,
              minHeight: 28,
              minWidth: 48,
            }}
          >
            {/* Disabled inputs swallow pointer events; let them pass through to this wrapper. */}
            <span
              className='d-inline-block'
              style={disabled ? {pointerEvents: 'none'} : undefined}
              data-testid={`${id}-switch-hit-layer`}
            >
              {switchControl}
            </span>
          </span>
        </OverlayTrigger>
      ) : (
        switchControl
      )}
      {helpText && (
        <Form.Text className={!!helpTextClass ? helpTextClass : 'text-muted'}>{helpText}</Form.Text>
      )}
    </div>
  )
}

export default ToggleSwitch
